'use strict';

var _regeneratorRuntime = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var strtok3 = require('strtok3');

var core = require('./core');

function fromFile(_x) {
  return _fromFile.apply(this, arguments);
}

function _fromFile() {
  _fromFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
    var tokenizer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return strtok3.fromFile(path);

          case 2:
            tokenizer = _context.sent;
            _context.prev = 3;
            _context.next = 6;
            return core.fromTokenizer(tokenizer);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.next = 10;
            return tokenizer.close();

          case 10:
            return _context.finish(7);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3,, 7, 11]]);
  }));
  return _fromFile.apply(this, arguments);
}

var fileType = {
  fromFile: fromFile
};
Object.assign(fileType, core);
Object.defineProperty(fileType, 'extensions', {
  get: function get() {
    return core.extensions;
  }
});
Object.defineProperty(fileType, 'mimeTypes', {
  get: function get() {
    return core.mimeTypes;
  }
});
module.exports = fileType;